import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getSchedule } from "@/lib/api";
import { PageHeader } from "@/components/dashboard/ui";
import { Video, MapPin, UsersRound, Calendar } from "lucide-react";

export default function Schedule() {
  const [items, setItems] = useState([]);
  useEffect(() => { getSchedule().then(setItems); }, []);
  const dot = { blue: "#1a5fd0", green: "#2f9e57", orange: "#e0842f", purple: "#7c53d6" };
  return (
    <div className="fade-in max-w-3xl">
      <PageHeader title="Schedule" subtitle="Tuesday, April 22, 2025" action={<span className="h-11 w-11 rounded-2xl bg-[#e8f1ff] grid place-items-center text-[#1a5fd0]"><Calendar size={20} /></span>} />
      <div className="card-soft p-6">
        <ul>
          {items.map((s, i) => (
            <li key={s.id} className="flex gap-4">
              <div className="w-20 shrink-0 text-right pt-1 text-[13px] font-bold text-slate-400">{s.time}</div>
              <div className="flex flex-col items-center pt-1.5"><span className="h-3 w-3 rounded-full" style={{ background: dot[s.color] }} />{i < items.length - 1 && <span className="w-px flex-1 bg-slate-100 my-1" />}</div>
              <div className="flex-1 pb-6">
                <div className="flex items-center justify-between"><div><div className="text-[15px] font-bold text-[#10233f]">{s.patient}</div><div className="text-[13px] text-slate-500">{s.type}{s.subtitle ? ` · ${s.subtitle}` : ""}</div></div>
                  {s.action === "Join" ? <Link to="/telehealth" className="btn-primary px-4 py-1.5 text-[13px] font-bold inline-flex items-center gap-1"><Video size={13} /> Join</Link>
                    : s.mode === "location" ? <span className="flex items-center gap-1 text-[13px] font-semibold text-slate-500"><MapPin size={14} /> {s.location}</span>
                      : s.mode === "group" ? <span className="flex items-center gap-1 text-[13px] font-semibold text-[#7c53d6]"><UsersRound size={14} /> {s.location}</span>
                        : <span className="flex items-center gap-1 text-[13px] font-semibold text-[#7c53d6]"><Video size={14} /> {s.location}</span>}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
